var render = function render(_c,_vm){return _c('span',[_c('div',{staticClass:"con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to",staticStyle:{"height":"20px"}},[_c('span',{staticClass:"span-text-validation"},[_vm._v(_vm._s(_vm.props.error))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }